export enum LoyaltyProgramStepStatus {
  Unknown,
  InProgress,
  Completed,
}
